import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils/cn";
import { useNotificationsStore } from "../stores/notificationsStore";
import type { ConnectionStatus } from "../types";

const tone: Record<ConnectionStatus, string> = {
  connected: "bg-success",
  reconnecting: "bg-warning animate-pulse",
  disconnected: "bg-danger",
};

/** Bolinha de status da conexão em tempo real (verde/amarela/vermelha). */
export function ConnectionStatusDot({ className }: { className?: string }) {
  const { t } = useTranslation("backoffice");
  const status = useNotificationsStore((s) => s.connectionStatus);
  const label = t(`notifications.connection.${status}`);
  return (
    <span
      role="status"
      title={label}
      aria-label={label}
      className={cn("inline-block h-1.5 w-1.5 shrink-0 rounded-full", tone[status], className)}
    />
  );
}
